<template lang="html">
  <div class="company-container flex spaced column">
    <div class="top-img">
      <div class="overlay overblue"></div>
      <img src="../assets/images/company/compage_main.png" alt="">
    </div>
    <div class="content-top text-white row">
      <div class="page-title--norm content-padded">
        Pesaflow has existed for 10 years <br class="desktop-only">and has had
        the privilege to <br class="desktop-only">provide several institutions with <br class="desktop-only">efficient payment solutions
      </div>
      <div class="flex wrap content-slim--desktop">
        <div class="content-padded content-mintext equal-width">
          Pesaflow is a homegrown, all-in-one payment system that powers revenue collection, payment aggregation, and business intelligence.
        </div>
        <div class="content-padded content-mintext equal-width">
          Pesaflow was built with Governments in mind as a simple and reliable way to collect payment services from the public and helping track every single coin from all transactions made.
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue white">
      <div class="content-margin">
        <div class="flex wrap">
          <div class="content-padded equal-width flex column">
            <div class="content-padded content-maintext">
              Our Drive
            </div>
            <div class="content-padded content-subtext container top-rule">
              Our focus is to tailor sustainable solutions and create cutting-edge software that not only
              impact organizations, but also the lives of the people they serve. We perceive all our engagements as
              partnerships and remain dedicated to our core mandate which is improving efficiency, productivity and
              transparency in all the projects we undertake.
            </div>
          </div>
          <div class="content-padded equal-width flex column">
            <div class="content-padded content-maintext">
              Our Beliefs
            </div>
            <div class="content-padded content-subtext container top-rule">
              Our strong belief and culture based on delivering innovative, sustainable solutions is driven by a deep
              understanding of our customer needs and first-hand experience moving government services from manual systems
              to digital workflows. We have proven expertise in technology and in depth knowledge of government processes
              that not only allow us to devise cutting edge solutions, but also propel us to offer valid input that adds
              value to the digitization process.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue light-blue">
      <div class="content-margin content-padded">
        <div class="content-maintext content-padded">
          The Team
        </div>
        <div class="content-subtext content-padded container top-rule">
          Our team comprises of highly qualified and experienced professionals who work together to maintain the highest
          quality delivery of Pesaflow. We continuously invest in training to remain relevant and updated on processes,
          domain knowledge and technology.
        </div>
      </div>
      <div class="content-margin flex wrap content-padded">
        <div class="flex third-width column">
          <div class="content-padded ">
            <img src="../assets/images/company/comp_agoro.png" alt="" class="headshot">
          </div>
          <div class="content-subtitle content-padded">
            Larry Agoro <br> CEO
          </div>
          <div class="content-subtext content-padded">
            Agoro has a background in Business Development, with experience spanning over 15 years.
            He is fun, super energetic and very practical and thoughtful in all his projects.
            He is very dedicated to his work and always gets the job done.
          </div>
        </div>
        <div class="flex third-width column">
          <div class="content-padded ">
            <img src="../assets/images/company/comp_evid.png" alt="" class="headshot">
          </div>
          <div class="content-subtitle content-padded">
            Evid Sibi <br> Director
          </div>
          <div class="content-subtext content-padded">
            Evid is a Software engineer with experience spanning over 10 years. He is a critical and
            creative thinker, willing to undertake new, daring enterprises and an affectionate leader who pushes his team to grow.
          </div>
        </div>
        <div class="flex third-width column">
          <div class="content-padded ">
            <img src="../assets/images/company/comp_larry.png" alt="" class="headshot">
          </div>
          <div class="content-subtitle content-padded">
            Larry Weya <br> Director
          </div>
          <div class="content-subtext content-padded">
            Weya is a Software engineer with experience spanning over 15 years. He is soft spoken but very well detailed in his work.
            He has vast knowledge in technology trends and has a strong desire for success.
          </div>
        </div>
        <div class="flex third-width column">
          <div class="content-padded ">
            <img src="../assets/images/company/comp_tom.png" alt="" class="headshot">
          </div>
          <div class="content-subtitle content-padded">
            Thomas Juma <br> Director
          </div>
          <div class="content-subtext content-padded">
            Tom is a Software engineer with experience spanning over 9 years. He is a fun-loving introvert
            who is self-driven and extremely reliable. He can always be counted on to deliver after looking at the finer details of all projects.
          </div>
        </div>
        <div class="flex third-width column">
          <div class="content-padded ">
            <img src="../assets/images/company/comp_charles.png" alt="" class="headshot">
          </div>
          <div class="content-subtitle content-padded">
            Charles Sewe <br> Director
          </div>
          <div class="content-subtext content-padded">
            Charles is a Software engineer with experience spanning over 9 years. He is the guy who makes people laugh
            and wants to make sure the team is taken care of. At the same time, he is very pensive and detail-oriented in his work.
          </div>
        </div>
        <div class="flex third-width column">
          <div class="content-padded ">
            <img src="../assets/images/company/comp_derek.png" alt="" class="headshot">
          </div>
          <div class="content-subtitle content-padded">
            Derek Ogare <br> Director
          </div>
          <div class="content-subtext content-padded">
            Derek is a User Experience designer, with expertise spanning over 9 years. He is quite the motivator and has a great way
            with people. He is also very inventive with keen attention to detail.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img">
        <div class="overlay dark-blue"></div>
        <img src="../assets/images/home/homepage_6.png" alt="">
      </div>
      <div class="row text-white container">
        <div class="top-spaced content-maintext content-padded content-slim">
          Your success and growth <br class="desktop-only"/>are our top priority.
        </div>
        <div class="content-subtext content-padded content-slim">
          Our teams are available to help, every <br class="desktop-only"/>step of the way.
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img med-blue">
        <img src="../assets/images/home/homepage_7.png" alt="">
      </div>
      <div class="row content-margin flex wrap spaced container">
        <div class="content-padded content-maintext">
          Scale your business or <br class="desktop-only"/>organization by tapping into <br class="desktop-only"/>
          the same powerful tools <br class="desktop-only"/>trusted by governments.
        </div>
        <div class="content-padded vertical-center flex">
          <button type="button" name="button" class="dark-blue text-white talk-btn">Talk to us today</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint max-len: 0 */
export default {
  name: 'Company',
};
</script>

<style lang="css" scoped>
.headshot {
  width: 70%;
}
</style>
